/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Close_MenuInputs */

const es_nav_close_menu = /** @type {(inputs: Nav_Close_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar menú`)
};

const gl_nav_close_menu = /** @type {(inputs: Nav_Close_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pechar menú`)
};

const en_nav_close_menu = /** @type {(inputs: Nav_Close_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close menu`)
};

/**
* | output |
* | --- |
* | "Close menu" |
*
* @param {Nav_Close_MenuInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_close_menu = /** @type {((inputs?: Nav_Close_MenuInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Close_MenuInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_nav_close_menu(inputs)
	if (locale === "en") return en_nav_close_menu(inputs)
	return es_nav_close_menu(inputs)
});